// extracted by mini-css-extract-plugin
module.exports = {"toggleWrapper":"ToggleSwitch_toggleWrapper__SXTkS","switch":"ToggleSwitch_switch__os9gR","slider":"ToggleSwitch_slider__g9rr3","shimmer":"ToggleSwitch_shimmer__Iw6Do"};